import { RpcClientContext } from "@redotech/redo-customer-portal-shared/contexts/rpc";
import { Address } from "@redotech/redo-model/draft-return/draft-return";
import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";

export const verifyAddressQueryKey = (address?: Address) =>
  ["verifyAddress", address] as const;

export const useVerifyAddress = ({ address }: { address?: Address }) => {
  const client = useContext(RpcClientContext);

  return useQuery({
    queryKey: verifyAddressQueryKey(address),
    queryFn: async () => {
      if (!client || !address) {
        throw new Error("Client or address is missing");
      }

      return await client.verifyAddress({
        address: { ...address, email: address.email.toLowerCase() },
      });
    },
    enabled: !!client && !!address,
  });
};
